/* eslint-disable */
import React, { useState } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

// core components
import styles from "assets/jss/llv/components/footerStyle.js";

const useStyles = makeStyles((theme) => ({
  ...styles,
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  closeButton: {
    padding: theme.spacing(1),
    cursor: "pointer"
  }
}));

export default function Footer(props) {
  const classes = useStyles();
  const [openConfidentialite, setOpenConfidentialite] = useState(false);
  const [openSecurite, setOpenSecurite] = useState(false);

  const handleOpenConfidentialite = () => setOpenConfidentialite(true);
  const handleCloseConfidentialite = () => setOpenConfidentialite(false);

  const handleOpenSecurite = () => setOpenSecurite(true);
  const handleCloseSecurite = () => setOpenSecurite(false);

  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div
          className={classes.row}
          style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
        >
          <div className={classes.col}>
            <button
              onClick={handleOpenConfidentialite}
              className={classes.a}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
                color: "#3c4858"
              }}
            >
              Politique de confidentialité
            </button>
          </div>
          <div className={classes.col}>
            <span className={classes.right}>
              &copy; 2019 - {new Date().getFullYear()}{" "}
              <a
                href="https://yakoafricassur.com"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.a}
              >
                YAKO AFRICA ASSURANCE VIE
              </a>
            </span>
          </div>
          <div className={classes.col}>
            <button
              onClick={handleOpenSecurite}
              className={classes.a}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
                color: "#3c4858"
              }}
            >
              Condition d'utilisation
            </button>
          </div>
        </div>
      </div>

      {/* Modal Politique de confidentialité */}
      <Dialog
        open={openConfidentialite}
        onClose={handleCloseConfidentialite}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <IconButton onClick={handleCloseConfidentialite} className={classes.closeButton}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers style={{ padding: 0, height: 1000, width: "100%" }}>
          <iframe
            src="https://yakoafricassur.com/politique/confident.html"
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="Politique de confidentialité"
          ></iframe>
        </DialogContent>
      </Dialog>

      {/* Modal Politique de sécurité */}
      <Dialog
        open={openSecurite}
        onClose={handleCloseSecurite}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <IconButton onClick={handleCloseSecurite} className={classes.closeButton}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers style={{ padding: 0, height: 1000, width: "100%" }}>
          <iframe
            src="https://yakoafricassur.com/politique/securite.html"
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="Politique de sécurité"
          ></iframe>
        </DialogContent>
      </Dialog>
    </footer>
  );
}
